import { ComputedRef, onBeforeUnmount, ref, Ref, watch } from 'vue';
import { SliderComponent } from '@workbench/core/dist/types/components/slider/slider';

const INNER_SELECTOR = '.wb-slider__inner';

// TODO: remove workaround after https://git.i.mercedes-benz.com/dh-io-workbench/core/issues/2451 is fixed
export const useAutoRotation = (
  slider: Ref<(HTMLElement & SliderComponent) | null>,
  count: ComputedRef<unknown[]>,
  intervalMs: number,
) => {
  const paused = ref(true);
  let interval: ReturnType<typeof setInterval> | undefined;
  let currenItem = 0;

  // The wb-slider is initialized after the onMounted so we have to watch the reference to add the listener
  watch(slider, () => {
    slider.value?.addEventListener('wbchange', changeCurrentItem as EventListener);
  });

  // remove listener before the deletion of the element
  onBeforeUnmount(() => {
    slider.value?.removeEventListener('wbchange', changeCurrentItem as EventListener);
  });

  // Set currentItem number and reset the rotation in case of manually changing current slide
  const changeCurrentItem = (event: CustomEvent<number>) => {
    currenItem = event.detail - 1;
    translateSliderItems();
    resetRotation();
  };

  // Translate current slide into viewport via transform-translate to fix the overflow issue with the
  // wb-slider and ppdwc & fin-widget popovers
  const translateSliderItems = (): void => {
    if (!slider.value || !slider.value.querySelector(INNER_SELECTOR)) return;

    slider.value.querySelector<HTMLElement>(INNER_SELECTOR)!.style.transform = `translateX(${currenItem * -100}%)`;
  };

  const startRotation = () => {
    if (interval) return;

    paused.value = false;

    interval = setInterval(() => {
      if (slider.value) {
        // Scroll to the first item, if it'l already showing the last slide
        if (currenItem === count.value.length - 1) {
          slider.value.scrollToItem(1);
        } else {
          slider.value.next();
        }
      }
    }, intervalMs);
  };

  const stopRotation = () => {
    if (!interval) return;

    paused.value = true;

    clearInterval(interval);
    interval = undefined;
  };

  const resetRotation = () => {
    if (interval) {
      clearInterval(interval);
      interval = undefined;
    }

    startRotation();
  };

  return {
    paused,
    startRotation,
    stopRotation,
    resetRotation,
  };
};
